/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-front
 * Version: 7.4.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import Switcher from '@kuik/modules/switcher/switcher.js';
import {closePanel, handleMobileActions} from './search-mobile.js';
import {handleDesktopActions} from './search-desktop.js';

/**
 * Gère le switch des composants.
 */
export function handleSwitch() {
  // On récupère les éléments du DOM qui font office de variantes
  // NB : on peut récupérer ces templates de la façon que l'on souhaite : dans le DOM, requête serveur, etc.
  const componentSearch = document.getElementById('component-search');
  const componentSearchDesktop = document.getElementById('component-search-desktop');
  // Enregistre le 1er composant en déclarant le switcher
  if (componentSearch) {
    const componentSwitcher = new Switcher('search-mobile', {
      element: componentSearch, onMounted() {
        handleMobileActions();
      }, onUnmounted() {
        closePanel();
      }
    });
    // Ajoute une 2e variante (exemple de composant asynchrone)
    componentSwitcher.registerComponent('search-desktop', {
      element: componentSearchDesktop, onMounted() {
        handleDesktopActions();
        const title = document.getElementById('search-result-title');
        if (title) {
          title.focus();
        }
      }
    });
    // Charger le composant mobile si la largeur de l'écran < 800px
    let lastWidth;
    new ResizeObserver(([{contentRect: {width}}]) => {
      if (lastWidth !== width) {
        lastWidth = width;
        componentSwitcher.switch(lastWidth >= 800 ? 'search-desktop' : 'search-mobile');
      }
    }).observe(document.body.parentElement);
    return componentSwitcher;
  }
}

handleSwitch();
